<template>
  <div class="row no-gutters d-flex align-items-center">
    <div class="col-md-5">

      <!-- Author image -->
      <div class="author-image-wrapper">
        <a :href="`/authors/${author.slug}`">
        <div class="responsive-aspect-ratio square-aspect-ratio">
          <img :src="author.avatar" class="w-100 h-100 rounded-circle object-fit-cover">
        </div>
        </a>
      </div>

    </div>

    <div class="col-md-7">

      <!-- Author content -->
      <div class="author-content-wrapper pl-0 pl-md-4 mt-2 mt-md-0 text-center text-md-left">
        <div class="author-title col-12 text-center">
          <a class="h6 mb-0" :href="`/authors/${author.slug}`">{{ author.name }}</a>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  name: "AuthorCard",
  props: {
    author: Object,
  }
}
</script>

<style scoped>

</style>
